import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { withAuthentication, withAuthorization } from '../_auth';
import DashboardPage from '../DashboardPage/DashboardPage';
import LoginPage from '../LoginPage/LoginPage';
import StoresPage from '../StoresPage/StoresPage';
import LeadsPage from '../LeadsPage/LeadsPage';
import UsersPage from '../UsersPage/UsersPage';
import AppPublicationsPage from '../AppPublicationsPage/AppPublicationsPage';

const condition = authUser => !!authUser && authUser.role === 'admin';

const AppRouter = () => (
    <Router>
        <div>
            <Switch>
                <Route path="/" exact component={withAuthorization(condition)(DashboardPage)} />
                <Route path="/login" component={LoginPage} />
                <Route path="/platforms/:platformId/stores" component={withAuthorization(condition)(StoresPage)} />
                <Route path="/leads" component={withAuthorization(condition)(LeadsPage)} />
                <Route path="/users" component={withAuthorization(condition)(UsersPage)} />
                <Route path="/app-publications" component={withAuthorization(condition)(AppPublicationsPage)} />
                <Redirect to="/" />
            </Switch>
        </div>
    </Router>
)

export default withAuthentication(AppRouter);